import { Container, Grid, Typography } from "@mui/material";
import styles from "../styles/MintTimeline.module.css";
import React from "react";
import { MintingWindowState, MintWindowParams } from "../types/mint";
import TimelineRow from "./TimelineRow";
import ENV from "../lib/env";

interface Props {
  mintWindowParams: MintWindowParams;
}

const MintTimeline = ({ mintWindowParams }: Props) => {
  return (
    <Grid container className={styles.timeline} id={"timeline"}>
      <Grid item sx={{ width: "100%", textAlign: "center" }} pt={15}>
        <Typography sx={{ fontWeight: 800, fontSize: "40px" }} mb={5}>
          Mint Timeline
        </Typography>
        <Container maxWidth="md">
          <Grid container sx={{ flexDirection: "column" }}>
            <TimelineRow
              name="Whitelist Mint"
              tag="First in line to mint, with special pricing."
              price="0.07 ETH"
              opensAt={ENV.OG_WINDOW_START_DATETIME}
              window="48hr"
              currentState={mintWindowParams.state}
              rowState={MintingWindowState.OG_MINT}
            />
            <TimelineRow
              name="Public Mint*"
              tag="*Public mint will only proceed if NFTs remain after previous mint windows."
              price="0.15 ETH"
              opensAt={ENV.PUBLIC_START_DATETIME}
              window={null}
              currentState={mintWindowParams.state}
              rowState={MintingWindowState.PUBLIC_MINT}
            />
          </Grid>
        </Container>
      </Grid>
    </Grid>
  );
};

export default MintTimeline;
